<template>
	<div class="user-info-mask" @click="onHide">
		<div class="user-info" :style="{ left: pos.x + 'px', top: pos.y + 'px' }" @click.stop>
			<div class="user-info-box">
				<div class="avatar">
					<head-image :name="user.nickName" :url="user.headImage" :size="60" :online="user.online"
						@click.native="showFullImage()" radius="10%"> </head-image>
				</div>
				<div class="info-card">
					<div class="header">
						<div class="nick-name" :class="{ 'official-name': user.userTag == 1 }">{{ user.nickName }}</div>
						<official-tag :user-tag="user.userTag" size="medium"></official-tag>
						<div v-if="user.sex == 0" class="icon iconfont icon-man" style="color: darkblue;"></div>
						<div v-if="user.sex == 1" class="icon iconfont icon-girl" style="color: darkred;"></div>
						<el-tag v-if="user.status == 1" size="mini" type="danger">已注销</el-tag>
						<el-tag v-if="user.isBanned" size="mini" type="danger">已封禁</el-tag>
						<el-tag v-if="user.isMuted" size="mini" type="warning">禁言中</el-tag>
					</div>
					<template>
						<div class="info-item">
							ID: {{ user.id }}
						</div>
						<div class="info-item" v-if="user.phone">
							手机号: {{ user.phone }}
						</div>
					</template>
					<div class="info-item">
						个性签名: {{ user.signature || '-' }}
					</div>
				</div>
			</div>
			<el-divider content-position="center"></el-divider>
			<div class="user-btn-group">
				<el-button v-if="isFriend" type="primary" @click="onSendMessage()">发消息</el-button>
				<span class="wait-text" v-else-if="isWaitingApprove">好友验证中</span>
				<el-button v-else-if="isAddFriend" type="primary" @click="onAddFriend()">加为好友</el-button>
				<el-button v-else-if="!canMute" type="primary" @click="onHide()">取消</el-button>
				<el-button v-if="canMute" type="danger" plain :loading="muteLoading" @click="onToggleMute">
					{{ user.isMuted ? '关闭禁言' : '开启禁言' }}
				</el-button>
			</div>
			<friend-apply ref="applyRef"></friend-apply>
		</div>
	</div>


</template>

<script>
import FriendApply from '../friend/FriendApply.vue';
import HeadImage from './HeadImage.vue';
import OfficialTag from './OfficialTag.vue';

export default {
	name: "userInfo",
	components: {
		HeadImage,
		OfficialTag,
		FriendApply
	},
	data() {
		return {
			muteLoading: false,
			muteReq: 0
		}
	},
	props: {
		user: {
			type: Object
		},
		pos: {
			type: Object
		}
	},
	watch: {
		'user.id': {
			immediate: true,
			handler() {
				this.refreshTargetUser();
			}
		}
	},
	methods: {
		onSendMessage() {
			let user = this.user;
			let chat = {
				type: 'PRIVATE',
				targetId: user.id,
				showName: user.nickName,
				headImage: user.headImage,
				userTag: user.userTag,
			};
			this.$store.commit("openChat", {...chat, activeChat: true});
			// this.$store.commit("activeChat", 0);
			if (this.$route.path != "/home/chat") {
				this.$router.push("/home/chat");
			}
			this.$emit("close");
		},
		onAddFriend() {
			this.$refs.applyRef.open(this.user);
		},
		onHide() {
			this.$emit("close");
		},
		showFullImage() {
			if (this.user.headImage) {
				this.$store.commit("showFullImageBox", this.user.headImage);
			}
		},
		refreshTargetUser() {
			if (!this.user || !this.user.id || !this.canMute) {
				return;
			}
			const req = ++this.muteReq;
			this.$http({
				url: `/user/find/${this.user.id}`,
				method: 'get'
			}).then((user) => {
				if (req !== this.muteReq || !user) {
					return;
				}
				this.$store.commit("showUserInfoBox", {
					...this.user,
					...user,
					isAddFriend: this.user.isAddFriend
				});
			});
		},
		onToggleMute() {
			if (!this.canMute || this.muteLoading) {
				return;
			}
			const isMuted = !this.user.isMuted;
			this.muteLoading = true;
			this.$http({
				url: '/user/mute',
				method: 'put',
				data: {
					userId: this.user.id,
					isMuted
				}
			}).then(() => {
				this.$set(this.user, 'isMuted', isMuted);
				if (isMuted) {
					this.$message.success(`已禁言'${this.user.nickName}'`);
				} else {
					this.$message.success(`已解除'${this.user.nickName}'的禁言`);
				}
				this.refreshTargetUser();
			}).finally(() => {
				this.muteLoading = false;
			});
		}
	},
	computed: {
		mine() {
			return this.$store.state.userStore.userInfo || {};
		},
		canMute() {
			if (!this.user || !this.user.id || !this.mine.id) {
				return false;
			}
			if (this.user.id == this.mine.id) {
				return false;
			}
			return !!this.$store.getters.canMuteUser;
		},
		isFriend() {
			return this.$store.getters.isFriend(this.user.id);
		},
		isAddFriend() {
			return this.user.isAddFriend;
		},
		isWaitingApprove() {
			return this.$store.getters.isInRecvRequest(this.user.id);
		}
	}
}
</script>

<style lang="scss">
.user-info-mask {
	background-color: rgba($color: #f4f4f4, $alpha: 0);
	position: fixed;
	left: 0;
	top: 0;
	right: 0;
	bottom: 0;
	z-index: 5;
}

.user-info {
	position: absolute;
	width: 300px;
	background-color: white;
	box-shadow: var(--im-box-shadow);
	border-radius: 4px;
	padding: 15px;

	.user-info-box {
		display: flex;
		align-items: center;

		.info-card {
			flex: 1;
			padding-left: 10px;

			.header {
				display: flex;
				align-items: center;
				gap: 4px;

				.nick-name {
					font-size: var(--im-font-size-large);
					font-weight: 600;
				}

				.icon {
					margin-left: 3px;
					font-size: var(--im-font-size);
				}

				.el-tag {
					margin-left: 3px;
				}
			}

			.info-item {
				font-size: var(--im-font-size);
				margin-top: 5px;
				word-break: break-all;

			}
		}

	}

	.el-divider--horizontal {
		margin: 18px 0;
	}

	.user-btn-group {
		display: flex;
		align-items: center;
		justify-content: center;
		flex-wrap: wrap;
		gap: 12px;
		text-align: center;

		.wait-text {
			font-size: 14px;
			color: var(--im-text-color-light);
		}
	}
}
</style>
